<template>
    <div class="calc-number-input">
        <InputNumber
            v-model="inputValue"
            :locale="$i18n.locale"
            :mode="mode"
            :currency="currency"
            :placeholder="translatedPlaceholder"
            :disabled="disabled"
            :class="['calc-input', { 'calc-input--invalid': invalid }]"
            :max-fraction-digits="maxFractionDigits"
            :min-fraction-digits="minFractionDigits"
            :input-id="inputId"
            :name="name"
            :input-inputmode="inputmode"
            @blur="$emit('blur', $event)"
            @focus="$emit('focus', $event)"
        />
    </div>
</template>

<script>
import InputNumber from 'primevue/inputnumber'

export default {
    name: 'CalcNumberInput',

    components: { InputNumber },

    props: {
        modelValue: {
            type: [Number, String, Object],
            default: null,
        },
        placeholder: {
            type: String,
            default: '',
        },
        mode: {
            type: String,
            default: 'currency',
        },
        currency: {
            type: String,
            default: 'EUR',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        maxFractionDigits: {
            type: Number,
            default: 2,
        },
        minFractionDigits: {
            type: Number,
            default: 0,
        },
        inputId: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        inputmode: {
            type: String,
            default: null,
        },
    },

    emits: ['update:modelValue', 'blur', 'focus'],

    computed: {
        translatedPlaceholder() {
            if (!this.placeholder) return ''
            if (this.placeholder.startsWith('§')) return this.$t(this.placeholder)
            return this.placeholder
        },

        inputValue: {
            get() {
                const v = this.modelValue
                return isNaN(parseFloat(v)) ? null : parseFloat(v)
            },
            set(value) {
                this.$emit('update:modelValue', value)
            },
        },
    },
}
</script>

<style scoped>
.calc-number-input {
    width: 100%;
}

.calc-number-input :deep(.p-inputnumber),
.calc-number-input :deep(.p-inputnumber input) {
    width: 100%;
}

.calc-number-input :deep(.p-inputnumber input) {
    height: 48px;
    border-radius: 8px;
    background: white;
    border: 1px solid var(--calc-line);
    padding: 0 16px;
    font-family: 'TWK Lausanne', 'Inter', sans-serif;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: -0.02em;
    color: var(--calc-ink);
    outline: none;
    transition:
        border-color var(--calc-t-fast),
        box-shadow var(--calc-t-fast);
    width: 100%;
}

.calc-number-input :deep(.p-inputnumber input)::placeholder {
    color: var(--calc-ink-30);
}

.calc-number-input :deep(.p-inputnumber input:focus) {
    border-color: var(--calc-line);
    box-shadow: 0 0 0 1px var(--calc-line);
}

.calc-number-input :deep(.p-inputnumber input:focus-visible) {
    outline: none;
}

.calc-number-input :deep(.calc-input--invalid input),
.calc-number-input :deep(.calc-input--invalid input:focus) {
    border-color: var(--calc-error, #d23030);
    box-shadow: 0 0 0 1px var(--calc-error, #d23030);
}
</style>
